module.exports = __webpack_public_path__ + "static/media/undraw_page_not_found_su7k.7e3de5e9.svg";